module.exports = __webpack_public_path__ + "media/sounds/tap_03-224e21ed30eb5c8bf0f802a5a3bc8d47.wav";